<template>
  <div class="container">
    <div class="row paymentFailed">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div class="text-center">
              <!-- <i class="fa-regular credit-card  fa-credit-card"></i>
              <i class="fa-solid fa-circle-xmark xmark"></i> -->
              <img src="/assets/images/icons/logo-false.png" class="logo-width" alt="">
            </div>
            <h4 class="pt-5">تعذّر إتمام عملية الدفع</h4>
            <p class="gray-text">نأسف، لم تكتمل عملية الدفع بنجاح. يُرجى المحاولة مرة أخرى أو التواصل <br>  معنا للمساعدة.</p>
          </div>
        </div>
        <div class="row justify-content-center pt-3">
          <div class="col col-md-7 text-center">
            <router-link to="/">
              <div class="btn-black font-22">عودة الى الرئيسية</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'failed',
}
</script>